import React, { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Especificacoes from './Especificacoes';
import ModoRouter from './ModoRouter';
import ModoAp from './ModoAp';
import ModoBridge from './ModoBridge';
import ModoMesh from './ModeMesh';
import Interferencias from './Interferencias';
import * as AiIcons from "react-icons/ai";
import * as BiIcons from "react-icons/bi";
import * as FaIcons from "react-icons/fa";
import RoteadorImg from "../../assets/images/roteador.png";

import './styles.css';
import TiposConexao from './TiposConexao';


const Roteador = () => {

    const [activeTab, setActiveTab] = useState('/conexao');

    const handleTabSelect = (selectedTab) => {
        setActiveTab(selectedTab);
    };

    return (
        <div className='tabs'>
            <div className="roteador">
                <h1>Orientações para configuração de roteadores</h1>
                <img src={RoteadorImg} alt="conexao" />
            </div>
            <Tab.Container activeKey={activeTab} onSelect={handleTabSelect}>
                <Nav fill variant="tabs" defaultActiveKey="/conexao">
                    <Nav.Item>
                        <Nav.Link eventKey="/conexao">
                            <div className='aba-menu'>
                            <h4><BiIcons.BiRss /></h4>
                                <h5>Tipos de Conexão</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>                    
                    <Nav.Item>
                        <Nav.Link eventKey="/router">
                            <div className='aba-menu'>
                            <h4><BiIcons.BiRss /></h4>
                                <h5>Modo Router</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/bridge">
                            <div className='aba-menu'>
                            <h4><BiIcons.BiRss /></h4>
                                <h5>Modo Bridge</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/ap">
                            <div className='aba-menu'>
                            <h4><BiIcons.BiRss /></h4>
                                <h5>Modo AP</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/mesh">
                            <div className='aba-menu'>
                            <h4><BiIcons.BiRss /></h4>
                                <h5>Modo Mesh</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/especificacoes">
                            <div className='aba-menu'>
                                <h4><AiIcons.AiFillSetting /></h4>
                                <h5>Especificações</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/interferencias">
                            <div className='aba-menu'>
                                <h4><FaIcons.FaSchlix /></h4>
                                <h5>Interferencias</h5>
                            </div>
                        </Nav.Link>
                    </Nav.Item>                    
                </Nav>
                <Tab.Content className='container'>
                    <Tab.Pane eventKey="/conexao">
                        <TiposConexao />
                    </Tab.Pane>                     
                    <Tab.Pane eventKey="/router">
                        <ModoRouter />
                    </Tab.Pane> 
                    <Tab.Pane eventKey="/bridge">
                        <ModoBridge />
                    </Tab.Pane> 
                    <Tab.Pane eventKey="/ap">
                        <ModoAp />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/mesh">
                        <ModoMesh />
                    </Tab.Pane>                    
                    <Tab.Pane eventKey="/interferencias">
                        <Interferencias />
                    </Tab.Pane>
                    <Tab.Pane eventKey="/especificacoes">
                        <Especificacoes />
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    );
};
export default Roteador;